import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import GetQuote from "./pages/GetQuote";
import Contact from "./pages/Contact";
import GalleryPage from "./pages/GalleryPage";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-neutral-900">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Header Navigation */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/fa-tilbud" element={<GetQuote />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default App;
